module.exports = __webpack_public_path__ + "static/img/1_1.d4d4f78b.png";